import { ExternalLink } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import { commandLinePackagingInstruction } from "../../Instructions";
import { CommonCommandLineTextForOctopusCliCodeSample, CommonTextForOctopusCli } from "../CommonRegistrationText";
export const CommandLinePackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging .NET applications from command line, we recommend using the <ExternalLink href={"cli"}>Octopus CLI</ExternalLink>.
        </p>
        {CommonTextForOctopusCli}
        {CommonCommandLineTextForOctopusCliCodeSample}
    </div>);
CommandLinePackaging.displayName = "CommandLinePackaging"
export default commandLinePackagingInstruction(() => <CommandLinePackaging />);
